import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import styles from './lineage-toggle.module.css';

type LineageToggleProps = {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	disabled?: boolean;
	// The nested public-retrieval option, which only exists on top of this one.
	children?: React.ReactNode;
};

export const LINEAGE_TOGGLE_LABEL = 'Agregar página de trazabilidad';

export const LineageToggle = ({
	checked,
	onCheckedChange,
	disabled,
	children,
}: LineageToggleProps) => (
	<div className={styles.panel} data-testid="lineage-toggle">
		<div className={styles.option}>
			<Checkbox
				id="lineage-page"
				checked={checked}
				disabled={disabled}
				onCheckedChange={(value) => onCheckedChange(value === true)}
			/>
			<Label htmlFor="lineage-page" className={styles.label}>
				{LINEAGE_TOGGLE_LABEL}
			</Label>
		</div>
		<p className={styles.description}>
			Se agrega una última página con un código QR y los datos del
			documento. Queda cubierta por tu firma y permite consultar el
			registro desde una copia impresa.
		</p>
		{children}
	</div>
);
